import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'

import { getDesigns } from "../../../store/design/actions"
import { getAreas, updateArea, deleteArea, addArea} from "../../../store/goals/actions"
import { Field, Form } from '@availity/form'
import '@availity/yup'
import * as yup from 'yup'

import { Auth } from 'aws-amplify';
import {
    Badge,
    Col,
    Collapse,
    CardHeader,
    CardImg,
    CardTitle,
    Button,
    Container,
    Dropdown,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    Nav,
    NavItem,
    Label,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Table,
    TabContent,
    TabPane,
    Input,

} from "reactstrap"
import { getAccountInfo } from "../../../store/admin/actions"
import { getPlantData, getClimateData, saveClimateData, getCustomClimate } from "../../../store/design/actions"
import { getProfile, editProfile } from "../../../store/auth/profile/actions"
import { userChangeSelfPassword } from "../../../store/auth/forgetpwd/actions"
//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

import { StorageImage } from '@aws-amplify/ui-react-storage';

import { Storage } from '@aws-amplify/storage'
// users
import user1 from "../../../assets/images/users/avatar-1.png"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const { onChangePassword, onGetAccountInfo, onFetchClimateData, onUpdateProfile, onGetProfile,
    session, profile, userClimates,onSaveClimateData, onGetCustomClimate, onLoadDesigns,onGetAreas } = props

  const [menu, setMenu] = useState(false)
  const [climateModel, setClimateModel] = useState()
    const [country, setCountry] = useState('US');
    const [province, setProvince] = useState('');

    const [username, setusername] = useState('')
  const [customer, setcustomer] = useState()
  const [oldPassword, setOldPassword] = useState()
  const [newPassword, setNewPassword] = useState()
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
  const [customClimate, setCustomClimate] = useState({})
  const [customClimateModal, setCustomClimateModal] = useState(false)
  const [changePassword, setChangePassword] = useState(false)
  const [editAddress, setEditAddress] = useState(false)
  const addressModalDismissed = React.useRef(false)
  const [editPreferences, setEditPreferences] = useState(false)
  const [editCustom, setEditCustom] = useState(false)
  const [address1, setStreetAddress1] = useState([])
  const [address2, setStreetAddress2] = useState([])
  const [city, setCity] = useState([])
  const [state, setState] = useState([])
  const [zipcode, setZipcode] = useState()
  const [climate, setClimate] = useState()
  const [zone, setZone] = useState()
  const [savedAddress, setSavedAddress] = useState(false)

  const [pickClimate, setPickClimate] = useState()
  const [climateName, setClimateName] = useState()
  const [janmin, setJanMin] = useState()
  const [janmax, setJanMax] = useState()
  const [febmin, setFebMin] = useState()
  const [febmax, setFebMax] = useState()
  const [marmin, setMarMin] = useState()
  const [marmax, setMarMax] = useState()
  const [aprmin, setAprMin] = useState()
  const [aprmax, setAprMax] = useState()
  const [maymin, setMayMin] = useState()
  const [maymax, setMayMax] = useState()
  const [junmin, setJunMin] = useState()
  const [junmax, setJunMax] = useState()
  const [julmin, setJulMin] = useState()
  const [julmax, setJulMax] = useState()
  const [augmin, setAugMin] = useState()
  const [augmax, setAugMax] = useState()
  const [sepmin, setSepMin] = useState()
  const [sepmax, setSepMax] = useState()
  const [octmin, setOctMin] = useState()
  const [octmax, setOctMax] = useState()
  const [novmin, setNovMin] = useState()
  const [novmax, setNovMax] = useState()
  const [decmin, setDecMin] = useState()
  const [decmax, setDecMax] = useState()
  const [unitmeasurement, setUnit] = useState([])

  useEffect(() => {
    if (localStorage.getItem("user") && username!='') {
        var user = JSON.parse(localStorage.getItem("user")).user
        setusername(user)
        onGetProfile(user)
        onGetAreas()
        onLoadDesigns()
    }
  }, [props.success])

  useEffect(() => {
    if (profile?.username) {
        if (profile.address==undefined && !addressModalDismissed.current) {
            setEditAddress(true)
            return
        } else {
           setEditAddress(false)
        }
    }
    if (profile?.climates && profile?.climates.length>0) {
       for (var i=0; i<profile.climates.length; i++) {
	   var customClimate = profile.climates[i]
	   if (customClimate.selected) {
	      setClimateModel(customClimate.name)
	      break;
	   }
       }
    }

  }, [profile])

  useEffect(() => {
     if (session.session)
	 window.location.href = session.session;
  }, [session])


  function getAccountInfo() {
    onGetAccountInfo (profile?.customer_id);
  }


function saveAddress() {
        // save this information to the user's profile
        var updatedProfile = {...profile}
        updatedProfile.address = {
            address1,
            address2,
            city,
            state,
            zipcode,
            country,
        }
        updatedProfile.zone = zone || ""
        updatedProfile.climate = climate || ""
        updatedProfile.setup = "completed"
        // Ensure fields the lambda always writes have safe defaults for new users
        updatedProfile.settings = profile.settings || {}
        updatedProfile.unitmeasurement = profile.unitmeasurement || ""
        updatedProfile.customer_id = profile.customer_id || ""
        updatedProfile.climates = profile.climates || []
        // A new user arrives here on onboarding step "address"; supplying it is
        // what completes that step and releases them to the Sector Map.
        if (updatedProfile.onboardingStep === "address")
            updatedProfile.onboardingStep = "site"
        addressModalDismissed.current = true
        setEditAddress(false)
        onUpdateProfile(updatedProfile)
   }

   function savePreferences() {
        var updatedProfile = {...profile}
        updatedProfile.unitmeasurement = unitmeasurement
        updatedProfile.setup = "completed"
        setEditPreferences(false)
        onUpdateProfile(updatedProfile)
   }

   function loadCustom(climateName) {
       if (climateName=="zipcode") {
         var updatedProfile = {...profile}
         for (var i=0; i<updatedProfile.climates.length; i++) {
             if (updatedProfile.climates[i].selected) {
                 updatedProfile.climates[i].selected = false
             }
         }
	 setEditCustom(false)
         onUpdateProfile(updatedProfile)
         return;
     }

       var climate;
       for (var i=0; i<profile.climates.length; i++) {
            if (profile.climates[i].name==climateName) {
                climate = profile.climates[i]
            }
        }
        if (!climate)
          return
       setClimateName (climate.name)
       setJanMin (climate.JanMin)
       setJanMax (climate.JanMax)
       setFebMin (climate.FebMin)
       setFebMax (climate.FebMax)
       setMarMin (climate.MarMin)
       setMarMax (climate.MarMax)
       setAprMin (climate.AprMin)
       setAprMax (climate.AprMax)
       setMayMin (climate.MayMin)
       setMayMax (climate.MayMax)
       setJunMin (climate.JunMin)
       setJunMax (climate.JunMax)
       setJulMin (climate.JulMin)
       setJulMax (climate.JulMax)
       setAugMin (climate.AugMin)
       setAugMax (climate.AugMax)
       setSepMin (climate.SepMin)
       setSepMax (climate.SepMax)
       setOctMin (climate.OctMin)
       setOctMax (climate.OctMax)
       setNovMin (climate.NovMin)
       setNovMax (climate.NovMax)
       setDecMin (climate.DecMin)
       setDecMax (climate.DecMax)
   }

   function initCustom() {
       for (var i=0; i<profile.climates.length; i++) {
            if (profile.climates[i].selected) {
                loadCustom(profile.climates[i].name)
            }
        }
   }

    function saveCustom() {
        // save this information to the user's profile
        var updatedProfile = {...profile}
        var customClimate = {
             "name" : climateName,
             "selected": true,
             "JanMin": janmin,
             "JanMax": janmax,
             "FebMin": febmin,
             "FebMax": febmax,
             "MarMin": marmin,
             "MarMax": marmax,
             "AprMin": aprmin,
             "AprMax": aprmax,
             "MayMin": maymin,
             "MayMax": maymax,
             "JunMin": junmin,
             "JunMax": junmax,
             "JulMin": julmin,
             "JulMax": julmax,
             "AugMin": augmin,
             "AugMax": augmax,
             "SepMin": sepmin,
             "SepMax": sepmax,
             "OctMin": octmin,
             "OctMax": octmax,
             "NovMin": novmin,
             "NovMax": novmax,
             "DecMin": decmin,
             "DecMax": decmax
        }
        var foundClimate = false
        if (!updatedProfile.climates)
             updatedProfile.climates = []
        for (var i=0; i<updatedProfile.climates.length; i++) {
            if (updatedProfile.climates[i].name==customClimate.name) {
                 updatedProfile.climates[i] = customClimate
                 foundClimate = true
            } else {
                 updatedProfile.climates[i].selected = false
            }
        }
        if (!foundClimate)
            updatedProfile.climates.push(customClimate)
        setEditCustom(false)
        onUpdateProfile(updatedProfile)
   }


  function changePasswordModal() {
    setChangePassword(true)
  }


  function customClimateData() {
     setCustomClimateModal(!customClimateModal)
  }

  function loadSavedClimate() {
     if (climate=="zipcode") {
	 var updatedProfile = {...profile}
	 for (var i=0; i<updatedProfile.climates.length; i++) {
             if (updatedProfile.climates[i].selected) {
	         updatedProfile.climates[i].selected = false
             }
	 }
         onUpdateProfile(updatedProfile)
	 return;
     }

     for (var i in userClimates) {
          if (userClimates[i].name==climate) {
             let newClimate = Object.assign({}, userClimates[i]);
             setCustomClimate(newClimate)
             setCustomClimateModal(!customClimateModal)
             break;
         }
     }
  }

   function changeAddressModal() {
    setStreetAddress1(profile.address.address1)
    setStreetAddress2(profile.address.address2)
    setZipcode(profile.address.zipcode)
       setCountry(profile.address.country)
    setState(profile.address.state)
    setCity(profile.address.city)
    setZone(profile.USDAzone || profile.zone || "")
    setClimate(profile.climate || "")
    setEditAddress(true)
  }

    function changePreferencesModal() {
      setZone(profile.USDAzone)
      setClimate(profile.climate)
      setUnit(profile.unitmeasurement)
       setEditPreferences(true)
    }

    function editCustomClimates() {
      initCustom()
      setEditCustom(true)
    }

    function closePassword() {
      setChangePassword(false)
        setError('')
    }


    const handleChangePassword = async (values) => {
        const { oldPassword, newPassword, verifyPassword } = values;

        setError(''); // Clear previous errors
        setSuccess(''); // Clear previous success messages

        try {
            // Check if newPassword matches verifyPassword
            if (newPassword !== verifyPassword) {
                setError('Passwords must match.');
                return;
            }

            // Validate newPassword locally if needed
            if (newPassword.length < 8) {
                setError('Password must be at least 8 characters long.');
                return;
            }
            if (!/\d/.test(newPassword)) {
                setError('Password must contain at least one number.');
                return;
            }
            if (!/[A-Z]/.test(newPassword)) {
                setError('Password must contain at least one uppercase letter.');
                return;
            }
            if (!/[a-z]/.test(newPassword)) {
                setError('Password must contain at least one lowercase letter.');
                return;
            }

            // Get current user and change password
            const user = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(user, oldPassword, newPassword);

            setSuccess('Password changed successfully!');
        } catch (err) {
            setError(err.message || 'An error occurred while changing the password.');
        }
    };

    return (
    <React.Fragment>
      {climateModel && <span style={{marginTop:"30px"}} className="d-none d-xl-inline-block ml-2 mr-1"><b>Custom Climate:</b> {climateModel}</span>}
      {climateModel===undefined && profile && profile.address && <span style={{marginTop:"30px"}} className="d-none d-xl-inline-block ml-2 mr-1"><b>Climate:</b> {profile.address.zipcode}</span>}
	  <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
	    src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ml-2 mr-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem tag="a" href="#">
            <a style={{color: '#555b6d'}} href="#"  onClick={() => { getAccountInfo()}}><i className="mdi mdi-settings font-size-17 align-middle mr-1"/>
            Account</a>
          </DropdownItem>
	   <DropdownItem tag="a" href="#">
            <a style={{color: '#555b6d'}} href="#"  onClick={() => { changePasswordModal()}}><i className="mdi mdi-settings font-size-17 align-middle mr-1"/>
            Change Password</a>
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <a style={{color: '#555b6d'}} href="#"  onClick={() => { changeAddressModal()}}><i className="mdi mdi-settings font-size-17 align-middle mr-1"/>
            Change Address</a>
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <a style={{color: '#555b6d'}} href="#"  onClick={() => { changePreferencesModal()}}><i className="mdi mdi-settings font-size-17 align-middle mr-1"/>
            Change Preferences</a>
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <a style={{color: '#555b6d'}} href="#"  onClick={() => { editCustomClimates()}}><i className="mdi mdi-settings font-size-17 align-middle mr-1"/>
            Edit Custom Climates</a>
          </DropdownItem>
          <div className="dropdown-divider"/>
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"/>
            <span>Logout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>


<Modal isOpen={changePassword} toggle={() => {

 }}
>
    <ModalHeader tag="h4">
        Change Password
    </ModalHeader>
    <ModalBody>

  { profile?.tempPassword &&
          <Row>
                       <Col md={12}>Since this is the first time you are logging in with a temporary password, we need you to change your password to something a bit more personal and secure.
                        If you forget your password in the future, you can follow the forgot password link on the Login page.</Col>
                  </Row>

           }
        <Form
            className="form-horizontal"
            onSubmit={handleChangePassword}
            initialValues={{
                oldPassword: '',
                newPassword: '',
                verifyPassword: '',
            }}
            validationSchema={yup.object().shape({
                oldPassword: yup.string().required('Old Password is required'),
                newPassword: yup.string().required('New Password is required'),
                verifyPassword: yup.string().required('Verify New Password is required'),
            })}
        >
            <div className="form-group">
                <Field
                    name="oldPassword"
                    label="Old Password"
                    className="form-control"
                    type="password"
                />
            </div>
            <div className="form-group">
                <Field
                    name="newPassword"
                    label="New Password"
                    className="form-control"
                    type="password"
                />
            </div>
            <div className="form-group">
                <Field
                    name="verifyPassword"
                    label="Verify New Password"
                    className="form-control"
                    type="password"
                />
            </div>

            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <Row className="form-group">
                <Col className="text-right">
                    <button
                        className="btn btn-primary w-md waves-effect waves-light"
                        type="submit"
                    >
                        Change
                    </button>
                    <button
                        className="btn btn-secondary w-md waves-effect waves-light"
                        type="button"
                        onClick={closePassword} // Optionally clear error on cancel
                    >
                        Close
                    </button>
                </Col>
            </Row>
        </Form>
    </ModalBody>
</Modal>


<Modal isOpen={editPreferences} toggle={() => {
 }}
>
    <ModalHeader tag="h4">
         SAGE Preferences
    </ModalHeader>
      <ModalBody>
        <Row>
                       <Col md={4}><b>Unit of Measurement</b></Col>
                       <Col md={7}>
                        <label
                  className={
                     unitmeasurement=="imperial"
                      ? "btn btn-sm btn-secondary active"
                      : "btn btn-sm btn-outline"
                  }
                > <input
                    type="radio"
                    name="unitmeasurement"
                    id="imperial"
                    onClick={() => {
                      setUnit("imperial");
                    }}
 />{" "}
                   Imperial
                </label>
                <label
                  className={
                     unitmeasurement=="metric"
                      ? "btn btn-sm btn-secondary active"
                      : "btn btn-sm btn-outline"
                  }
                > <input
                    type="radio"
                    name="unitmeasurement"
                    id="metric"
                    onClick={() => {
                      setUnit("metric");
                    }}
 />{" "}
                   Metric
                </label></Col>
                  </Row>
               <Row>
                <Col>
                    <Button
                                      onClick={e => { savePreferences()  }}
                                      color="info"
                                      className="btn-sm"
                                    >
                                        Save
                                    </Button>
                       <Button
                                      onClick={e => { setEditPreferences(false)  }}
                                      color="secondary"
                                      className="btn-sm"
                                    >
                                        Cancel
                                    </Button>
                  </Col>
                </Row>
      </ModalBody>
</Modal>

        {profile &&
<Modal isOpen={editCustom} toggle={() => {
 }}
>
    <ModalHeader tag="h4">
         Custom Climate
    </ModalHeader>
      <ModalBody>
         <Row>
            <Col>Choose an existing saved climate or US zipcode</Col>
            <Col> <select name="climateName"
                     onChange={event => {
                               setPickClimate(event.target.value);
                          }}>
	                   <option value=""></option>
                          <option value="zipcode">Use USA Zipcode</option>
                               {profile.climates && profile.climates.length>0 && profile.climates.map(
                        (climateItem) => <option value={climateItem.name}>{climateItem.name}</option>
                   )}
                          </select>
                       <Button
                                      onClick={e => { loadCustom(pickClimate)  }}
                                      color="success"
                                      className="btn-success btn-sm"
                                    >
                                        Select
                                    </Button>
                                    </Col>

         </Row>
         <Row>
            <Col><span>Create new custom climate/edit existing climate.  You have chosen <b>{profile.unitmeasurement}</b> as your preference for your system of measurement,
            so please enter your temperatures in <b>{profile.unitmeasurement=='imperial'?'Fahrenheit':'Celsius'}</b>.  For each month, enter the average low temperature
            and average high temperature.  Give the climate a name and press the Save button.</span></Col>
            </Row>
             <Row style={{marginTop:"20px"}}>
                       <Col md={4}><b>Selected Climate Name:</b></Col>
                       <Col md={7}><Input type="text" value={climateName}
                             onChange={event => {
                               setClimateName(event.target.value);
                          }}/>
                       </Col>

                  </Row>
        <Row style={{marginTop:"20px"}}>
                       <Col md={3}><b>Jan Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="janmin"
                    id="janmin"
                    value={janmin}
                     onChange={event => {
                               setJanMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Jan Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="janmax"
                    value={janmax}
                    id="jaxmax"
                     onChange={event => {
                               setJanMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
           <Row>
                       <Col md={3}><b>Feb Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="febmin"
                    value={febmin}
                    id="febmin"
                     onChange={event => {
                               setFebMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Feb Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="febmax"
                    value={febmax}
                    id="febmax"
                     onChange={event => {
                               setFebMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
               <Row>
                       <Col md={3}><b>Mar Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="marmin"
                    id="marmin"
                    value={marmin}
                     onChange={event => {
                               setMarMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Mar Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="marmax"
                    value={marmax}
                    id="marmax"
                     onChange={event => {
                               setMarMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
               <Row>
                       <Col md={3}><b>Apr Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Aprmin"
                    value={aprmin}
                    id="Aprmin"
                     onChange={event => {
                               setAprMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Apr Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Aprmax"
                    id="Aprmax"
                    value={aprmax}
                     onChange={event => {
                               setAprMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
               <Row>
                       <Col md={3}><b>May Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Maymin"
                    value={maymin}
                    id="Maymin"
                     onChange={event => {
                               setMayMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>May Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Maymax"
                    id="Maymax"
                    value={maymax}
                     onChange={event => {
                               setMayMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Jun Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Junmin"
                    id="Junmin"
                    value={junmin}
                     onChange={event => {
                               setJunMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Jun Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Junmax"
                    id="Junmax"
                    value={junmax}
                     onChange={event => {
                               setJunMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Jul Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Julmin"
                    id="Julmin"
                    value={julmin}
                     onChange={event => {
                               setJulMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Jul Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Julmax"
                    id="Julmax"
                    value={julmax}
                     onChange={event => {
                               setJulMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Aug Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Augmin"
                    id="Augmin"
                    value={augmin}
                     onChange={event => {
                               setAugMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Aug Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Augmax"
                    id="Augmax"
                    value={augmax}
                     onChange={event => {
                               setAugMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Sep Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Sepmin"
                    id="Sepmin"
                    value={sepmin}
                     onChange={event => {
                               setSepMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Sep Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Sepmax"
                    value={sepmax}
                    id="Sepmax"
                     onChange={event => {
                               setSepMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Oct Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Octmin"
                    id="Octmin"
                    value={octmin}
                     onChange={event => {
                               setOctMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Oct Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Octmax"
                    value={octmax}
                    id="Octmax"
                     onChange={event => {
                               setOctMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Nov Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Novmin"
                    id="Novmin"
                    value={novmin}
                     onChange={event => {
                               setNovMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Nov Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    value={novmax}
                    name="Novmax"
                    id="Novmax"
                     onChange={event => {
                               setNovMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
                   <Row>
                       <Col md={3}><b>Dec Min:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Decmin"
                    id="Decmin"
                    value={decmin}
                     onChange={event => {
                               setDecMin(event.target.value);
                          }}/>

                       </Col>
                       <Col md={3}><b>Dec Max:</b></Col>
                       <Col md={3}>
                        <Input
                    type="text"
                    name="Decmax"
                    id="Decmax"
                    value={decmax}
                     onChange={event => {
                               setDecMax(event.target.value);
                          }}/>

                       </Col>
                  </Row>
               <Row>
                <Col>
                    <center><Button
                                      onClick={e => { saveCustom()  }}
                                      color="info"
                                      className="btn-sm"
                                    >
                                        Save
                                    </Button>
                                    <Button
                                      onClick={e => { setEditCustom(false)  }}
                                      color="secondary"
                                      className="btn-sm"
                                    >
                                        Cancel
                                    </Button>
                      </center>
                  </Col>
                </Row>
      </ModalBody>
</Modal>
        }

<Modal isOpen={editAddress} toggle={() => {
 }}
>
    <ModalHeader tag="h4">
         Enter Address
    </ModalHeader>
      <ModalBody>
      { !profile?.address &&
          <Row>
                       <Col md={12}>
                           <h5>Welcome to SAGE!  We need to collect some basic information about your address and
                               preferences for things like climate, unit of measurement,
                               and climate. </h5> <br/>
                               <h5>These will help SAGE to automatically calculate planting dates for your plants or give recommendations
                               about plants that are native to your climate.</h5>
                       </Col>

                       </Row>

           }
         <Form>

              <Row>
                       <Col md={5}><b>Street Address 1</b></Col>
                       <Col md={7}><Input type="text" value={address1} onChange={event => {
                                         setStreetAddress1(event.target.value);
                                      }}
                                   /></Col>
                  </Row>
             <Row>
                       <Col md={5}><b>Street Address 2</b></Col>
                       <Col md={7}><Input type="text" value={address2} onChange={event => {
                                         setStreetAddress2(event.target.value);
                                      }}
                                   /></Col>
                  </Row>
                   <Row>
                       <Col md={5}><b>City</b></Col>
                       <Col md={7}><Input type="text" value={city} onChange={event => {
                                         setCity(event.target.value);
                                      }}
                                   /></Col>
                  </Row>
            <Row>
                       <Col md={5}><b>State/Province/Territory</b></Col>
                       <Col md={7}><Input type="text" value={state} onChange={event => {
                                         setState(event.target.value);
                                      }}
                                   />
                              </Col>
                  </Row>

             <Row>
                 <Col md={5}><b>Country</b></Col>
                 <Col md={7}>
                     <Input
                         type="select"
                         value={country}
                         onChange={e => setCountry(e.target.value)}
                     >
                         <option value="">Select Country</option>
                         <option value="AF">Afghanistan</option>
                         <option value="AL">Albania</option>
                         <option value="DZ">Algeria</option>
                         <option value="AD">Andorra</option>
                         <option value="AO">Angola</option>
                         <option value="AG">Antigua and Barbuda</option>
                         <option value="AR">Argentina</option>
                         <option value="AM">Armenia</option>
                         <option value="AU">Australia</option>
                         <option value="AT">Austria</option>
                         <option value="AZ">Azerbaijan</option>
                         <option value="BS">Bahamas</option>
                         <option value="BH">Bahrain</option>
                         <option value="BD">Bangladesh</option>
                         <option value="BB">Barbados</option>
                         <option value="BY">Belarus</option>
                         <option value="BE">Belgium</option>
                         <option value="BZ">Belize</option>
                         <option value="BJ">Benin</option>
                         <option value="BT">Bhutan</option>
                         <option value="BO">Bolivia</option>
                         <option value="BA">Bosnia and Herzegovina</option>
                         <option value="BW">Botswana</option>
                         <option value="BR">Brazil</option>
                         <option value="BN">Brunei</option>
                         <option value="BG">Bulgaria</option>
                         <option value="BF">Burkina Faso</option>
                         <option value="BI">Burundi</option>
                         <option value="CV">Cabo Verde</option>
                         <option value="KH">Cambodia</option>
                         <option value="CM">Cameroon</option>
                         <option value="CA">Canada</option>
                         <option value="CF">Central African Republic</option>
                         <option value="TD">Chad</option>
                         <option value="CL">Chile</option>
                         <option value="CN">China</option>
                         <option value="CO">Colombia</option>
                         <option value="KM">Comoros</option>
                         <option value="CD">Congo (Democratic Republic)</option>
                         <option value="CG">Congo (Republic)</option>
                         <option value="CR">Costa Rica</option>
                         <option value="CI">Côte d’Ivoire</option>
                         <option value="HR">Croatia</option>
                         <option value="CU">Cuba</option>
                         <option value="CY">Cyprus</option>
                         <option value="CZ">Czech Republic</option>
                         <option value="DK">Denmark</option>
                         <option value="DJ">Djibouti</option>
                         <option value="DM">Dominica</option>
                         <option value="DO">Dominican Republic</option>
                         <option value="EC">Ecuador</option>
                         <option value="EG">Egypt</option>
                         <option value="SV">El Salvador</option>
                         <option value="GQ">Equatorial Guinea</option>
                         <option value="ER">Eritrea</option>
                         <option value="EE">Estonia</option>
                         <option value="SZ">Eswatini</option>
                         <option value="ET">Ethiopia</option>
                         <option value="FJ">Fiji</option>
                         <option value="FI">Finland</option>
                         <option value="FR">France</option>
                         <option value="GA">Gabon</option>
                         <option value="GM">Gambia</option>
                         <option value="GE">Georgia</option>
                         <option value="DE">Germany</option>
                         <option value="GH">Ghana</option>
                         <option value="GR">Greece</option>
                         <option value="GD">Grenada</option>
                         <option value="GT">Guatemala</option>
                         <option value="GN">Guinea</option>
                         <option value="GW">Guinea-Bissau</option>
                         <option value="GY">Guyana</option>
                         <option value="HT">Haiti</option>
                         <option value="HN">Honduras</option>
                         <option value="HU">Hungary</option>
                         <option value="IS">Iceland</option>
                         <option value="IN">India</option>
                         <option value="ID">Indonesia</option>
                         <option value="IR">Iran</option>
                         <option value="IQ">Iraq</option>
                         <option value="IE">Ireland</option>
                         <option value="IL">Israel</option>
                         <option value="IT">Italy</option>
                         <option value="JM">Jamaica</option>
                         <option value="JP">Japan</option>
                         <option value="JO">Jordan</option>
                         <option value="KZ">Kazakhstan</option>
                         <option value="KE">Kenya</option>
                         <option value="KI">Kiribati</option>
                         <option value="KW">Kuwait</option>
                         <option value="KG">Kyrgyzstan</option>
                         <option value="LA">Laos</option>
                         <option value="LV">Latvia</option>
                         <option value="LB">Lebanon</option>
                         <option value="LS">Lesotho</option>
                         <option value="LR">Liberia</option>
                         <option value="LY">Libya</option>
                         <option value="LI">Liechtenstein</option>
                         <option value="LT">Lithuania</option>
                         <option value="LU">Luxembourg</option>
                         <option value="MG">Madagascar</option>
                         <option value="MW">Malawi</option>
                         <option value="MY">Malaysia</option>
                         <option value="MV">Maldives</option>
                         <option value="ML">Mali</option>
                         <option value="MT">Malta</option>
                         <option value="MH">Marshall Islands</option>
                         <option value="MR">Mauritania</option>
                         <option value="MU">Mauritius</option>
                         <option value="MX">Mexico</option>
                         <option value="FM">Micronesia</option>
                         <option value="MD">Moldova</option>
                         <option value="MC">Monaco</option>
                         <option value="MN">Mongolia</option>
                         <option value="ME">Montenegro</option>
                         <option value="MA">Morocco</option>
                         <option value="MZ">Mozambique</option>
                         <option value="MM">Myanmar</option>
                         <option value="NA">Namibia</option>
                         <option value="NR">Nauru</option>
                         <option value="NP">Nepal</option>
                         <option value="NL">Netherlands</option>
                         <option value="NZ">New Zealand</option>
                         <option value="NI">Nicaragua</option>
                         <option value="NE">Niger</option>
                         <option value="NG">Nigeria</option>
                         <option value="MK">North Macedonia</option>
                         <option value="NO">Norway</option>
                         <option value="OM">Oman</option>
                         <option value="PK">Pakistan</option>
                         <option value="PW">Palau</option>
                         <option value="PA">Panama</option>
                         <option value="PG">Papua New Guinea</option>
                         <option value="PY">Paraguay</option>
                         <option value="PE">Peru</option>
                         <option value="PH">Philippines</option>
                         <option value="PL">Poland</option>
                         <option value="PT">Portugal</option>
                         <option value="QA">Qatar</option>
                         <option value="RO">Romania</option>
                         <option value="RU">Russia</option>
                         <option value="RW">Rwanda</option>
                         <option value="KN">Saint Kitts and Nevis</option>
                         <option value="LC">Saint Lucia</option>
                         <option value="VC">Saint Vincent and the Grenadines</option>
                         <option value="WS">Samoa</option>
                         <option value="SM">San Marino</option>
                         <option value="ST">Sao Tome and Principe</option>
                         <option value="SA">Saudi Arabia</option>
                         <option value="SN">Senegal</option>
                         <option value="RS">Serbia</option>
                         <option value="SC">Seychelles</option>
                         <option value="SL">Sierra Leone</option>
                         <option value="SG">Singapore</option>
                         <option value="SK">Slovakia</option>
                         <option value="SI">Slovenia</option>
                         <option value="SB">Solomon Islands</option>
                         <option value="SO">Somalia</option>
                         <option value="ZA">South Africa</option>
                         <option value="KR">South Korea</option>
                         <option value="SS">South Sudan</option>
                         <option value="ES">Spain</option>
                         <option value="LK">Sri Lanka</option>
                         <option value="SD">Sudan</option>
                         <option value="SR">Suriname</option>
                         <option value="SE">Sweden</option>
                         <option value="CH">Switzerland</option>
                         <option value="SY">Syria</option>
                         <option value="TJ">Tajikistan</option>
                         <option value="TZ">Tanzania</option>
                         <option value="TH">Thailand</option>
                         <option value="TL">Timor-Leste</option>
                         <option value="TG">Togo</option>
                         <option value="TO">Tonga</option>
                         <option value="TT">Trinidad and Tobago</option>
                         <option value="TN">Tunisia</option>
                         <option value="TR">Turkey</option>
                         <option value="TM">Turkmenistan</option>
                         <option value="TV">Tuvalu</option>
                         <option value="UG">Uganda</option>
                         <option value="UA">Ukraine</option>
                         <option value="AE">United Arab Emirates</option>
                         <option value="GB">United Kingdom</option>
                         <option value="US">United States</option>
                         <option value="UY">Uruguay</option>
                         <option value="UZ">Uzbekistan</option>
                         <option value="VU">Vanuatu</option>
                         <option value="VE">Venezuela</option>
                         <option value="VN">Vietnam</option>
                         <option value="YE">Yemen</option>
                         <option value="ZM">Zambia</option>
                         <option value="ZW">Zimbabwe</option>
                     </Input>

                 </Col>
             </Row>
                   <Row>
                       <Col md={5}><b>Postal Code</b></Col>
                       <Col md={4}><Input type="text" value={zipcode} onChange={event => {
                                         setZipcode(event.target.value);
                                      }}
                                   /></Col>
                  </Row>
                  <Row style={{marginTop:"10px"}}>
                       <Col md={5}><b>Climate</b></Col>
                       <Col md={7}>
                           <Input type="select" value={climate} onChange={event => setClimate(event.target.value)}>
                               <option value="">— select —</option>
                               <option value="Subtropical">Subtropical</option>
                               <option value="Tropical">Tropical</option>
                               <option value="Temperate">Temperate</option>
                               <option value="Mediterranean">Mediterranean</option>
                               <option value="Cold Desert">Cold Desert</option>
                               <option value="Hot Desert">Hot Desert</option>
                               <option value="Cool Temperate">Cool Temperate</option>
                           </Input>
                       </Col>
                  </Row>
                  <Row style={{marginTop:"6px"}}>
                       <Col md={5}><b>USDA Zone</b></Col>
                       <Col md={7}>
                           <Input type="select" value={zone || ""} onChange={event => setZone(event.target.value)}>
                               <option value=""></option>
                               <option value="1">1a-1b</option>
                               <option value="2">2a-2b</option>
                               <option value="3">3a-3b</option>
                               <option value="4">4a-4b</option>
                               <option value="5">5a-5b</option>
                               <option value="6">6a-6b</option>
                               <option value="7">7a-7b</option>
                               <option value="8">8a-8b</option>
                               <option value="9">9a-9b</option>
                               <option value="10">10a-10b</option>
                               <option value="11">11a-11b</option>
                               <option value="12">12a-12b</option>
                           </Input>
                       </Col>
                  </Row>
                <Row style={{marginTop:"10px"}}>
                <Col>
                    {profile?.address && <center>
                        <Button
                            onClick={e => {
                                saveAddress()
                            }}
                            color="info"
                            className="btn-sm"
                        >
                            Save
                        </Button>

                        <Button
                            onClick={e => {
                                addressModalDismissed.current = true
                                setEditAddress(false)
                            }}
                            color="secondary"
                            className="btn-sm"
                        >
                            Cancel
                        </Button>
                    </center>
                    }
                    {!profile?.address && <center>
                        <Button
                            onClick={e => {
                                saveAddress()
                            }}
                            color="info"
                            className="btn-sm"
                        >
                            Next
                        </Button>
                    </center>
                    }
                  </Col>
                </Row>
        </Form>
    </ModalBody>
</Modal>


    </React.Fragment>
)
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStateToProps = state => {
 return({
  session: state.admin.session,
  profile: state.Profile.user,
  climateData: state.designer.temps
 })
}


const mapDispatchToProps = dispatch => ({
  onGetAccountInfo: (customer_id) => dispatch(getAccountInfo(customer_id)),
  onGetProfile: (username) => dispatch (getProfile(username)),
    onLoadDesigns: () => dispatch(getDesigns()),
    onGetAreas: () => dispatch(getAreas()),
    onUpdateProfile: (profile) => dispatch (editProfile(profile)),
    onFetchClimateData: (zipcode) => dispatch(getClimateData(zipcode)),
    onGetCustomClimate: (username) => dispatch(getCustomClimate(username)),
  onChangePassword: (oldPassword, newPassword) => dispatch (userChangeSelfPassword(oldPassword, newPassword))
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProfileMenu))

